import React, { useContext, useEffect, useReducer } from 'react';
// import { Grid, Row, Col } from "react-bootstrap";
// import Card from "../../components/Card/Card";
import MainContext from '../../../../store/MainContext';
import API from '../../../../api/axios';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
// import Checkbox from '@material-ui/core/Checkbox';
// import FormGroup from '@material-ui/core/FormGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import StripedTable from '../../../../components/Table/StripedTable';
import Loading from '../../../../components/OtherElements/Loading';
import Pagination from '../../../../components/OtherElements/Pagination';
import TwoCards from '../../../../components/Card/TwoCards';
// import Dialog from "../../components/Dialog/DefaultDialog"
import useRules from '../../../../hooks/useRules';
import useTitle from 'hooks/useTitle';

function CargoTypes(props) {
  useTitle('انواع محموله');
  const main = useContext(MainContext);
  const [rules, hasRule, isAdmin] = useRules();
  const thArray = [
    'نام بار',
    'نیاز به کارگر',
    'درصد خطر',
    'نمک است؟',
    'ویرایش',
    'حذف',
  ];
  const itemsCountPerPage = main.state.Props.itemsCountPerPage;
  const initialState = {
    cargoTypes: [],
    isLoaded: false,
    fields: {
      title: '',
      worker: false,
      salt: false,
      dangerous: 0,
      search: '',
    },
    select: '',
    mode: 'add',
  };
  // Functions:

  // --- Functions for Reducers:

  function reducer(state, action) {
    const oldFields = state.fields;
    switch (action.type) {
      case 'LOADING':
        return { ...state, isLoaded: false };
      case 'LOADED':
        return { ...state, isLoaded: true };
      case 'CARGO_TYPES':
        return {
          ...state,
          cargoTypes: action.payload,
          isLoaded: true,
        };
      case 'CHANGE_FIELDS':
        const value =
          action.payload.type === 'checkbox'
            ? action.payload.checked
            : action.payload.value;
        const name = action.payload.name;
        const fields = state.fields;
        return {
          ...state,
          fields: {
            ...fields,
            [name]: value,
          },
        };
      case 'EDIT_CARGO':
        return {
          ...state,
          fields: {
            ...state.fields,
            title: action.payload.title ? action.payload.title : '',
            dangerous: action.payload.dangerous ? action.payload.dangerous : 0,
            worker: action.payload.worker ? action.payload.worker : false,
            salt: action.payload.salt ? action.payload.salt : false,
          },
          mode: 'edit',
          select: action.payload._id,
        };
      case 'RESET_FORM':
        return initialState;
      default:
        return { ...state };
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  // -- End of Reducer's functions
  // --- Other Functions :
  function searchQuery(page = 1, limit = itemsCountPerPage, search = '') {
    API(
      `/api/v1/admin/cargo/type/paginate/${page}/${limit}/?search=${search}`,
      {
        method: 'get',
      }
    )
      .then((res) => {
        dispatch({ type: 'CARGO_TYPES', payload: res.data });
      })
      .catch((er) => {
        console.error(er);
      });
  }
  const handleSearch = (e) => {
    handleChangeFields(e);
    searchQuery(1, itemsCountPerPage, e.target.value);
  };
  const handleEditCargo = (cargoID) => {
    API(`/api/v1/admin/cargo/type/${cargoID}`, {
      method: 'get',
    })
      .then((res) => {
        dispatch({ type: 'EDIT_CARGO', payload: res.data });
      })
      .catch((err) => {
        console.error(err);
        props.showMessage(3, 'tl', 'خطا', 'بروز خطا');
      });
  };
  const handlePageChange = (pageNumber) => {
    searchQuery(pageNumber);
  };
  const handleDeleteCargo = (id) => {
    API(`/api/v1/admin/cargo/type/${id}`, {
      method: 'delete',
    })
      .then((res) => {
        props.showMessage(2, 'tl', 'حذف', 'با موفقیت حذف گردید.');
        searchQuery();
      })
      .catch((err) => {
        props.showMessage(3, 'tl', 'خطا', 'بروز خطا');
        console.error(err);
      });
  };

  const handleChangeFields = (e) => {
    dispatch({ type: 'CHANGE_FIELDS', payload: e.target });
  };
  const handleSubmitCargoType = async () => {
    const errors = {};
    if (state.fields.title === '') {
      errors.title = 'عنوان نباید خالی باشد.';
    }
    const errorArray = [];
    Object.keys(errors).forEach(function (item) {
      errorArray.push(errors[item]);
    });
    if (errorArray.length > 0) {
      props.showMessage(
        3,
        'tl',
        'خطا',
        errorArray.map((e, i) => <li key={i}>{e}</li>)
      );
    } else {
      let l;
      if (state.mode === 'add') {
        l = `/api/v1/admin/cargo/type/`;
      } else {
        l = `/api/v1/admin/cargo/type/${state.select}`;
      }
      API(l, {
        method: state.mode === 'add' ? 'post' : 'put',
        data: {
          title: state.fields.title,
          worker: state.fields.worker,
          salt: state.fields.salt,
          dangerous: state.fields.dangerous,
        },
      })
        .then((res) => {
          const t = state.mode === 'add' ? 'افزودن' : 'ویرایش';
          const m =
            state.mode === 'add'
              ? 'افزودن با موفقیت انجام شد'
              : 'ویرایش با موفقیت انجام پذیرفت';
          props.showMessage(1, 'tl', t, m);
          dispatch({ type: 'RESET_FORM' });
          searchQuery();
        })
        .catch((err) => {
          props.showMessage(3, 'tl', 'خطا', 'بروز خطا');
          console.error(err);
        });
    }
  };

  // --- end of functions
  // -- First Render

  useEffect(() => {
    searchQuery();
  }, []);
  // ----
  // --- JSX Variables:
  const cargoTypesTable = state.isLoaded ? (
    <div className="cargo-types-table">
      <StripedTable
        thArray={thArray}
        tdArray={state.cargoTypes.docs.map((c) => [
          c.title,
          c.worker === true ? 'بله' : 'خیر',
          c.dangerous,
          c.salt === true ? 'بله' : 'خیر',
          <IconButton onClick={() => handleEditCargo(c._id)}>
            <EditIcon />
          </IconButton>,
          // <i
          //   className="pe-7s-note"
          //   data-id={c._id}
          //   style={{ color: "green", fontSize: "24px", cursor: "pointer" }}
          //   onClick={handleEditCargo}
          // />
          hasRule('parameters_cargo_can_delete') ? (
            <IconButton onClick={() => handleDeleteCargo(c._id)}>
              <DeleteIcon />
            </IconButton>
          ) : (
            ''
          ),
          // <i
          //   className="pe-7s-trash"
          //   data-id={c._id}
          //   style={{ color: "red", fontSize: "24px", cursor: "pointer" }}
          //   onClick={handleDeleteCargo}
          // />
        ])}
      />
      <Pagination
        activePage={state.cargoTypes.page}
        itemsCountPerPage={state.cargoTypes.limit}
        totalItemsCount={state.cargoTypes.totalDocs}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
      />
    </div>
  ) : (
    <Loading text="در حال بارگیری انواع بار ..." />
  );
  const theForm = (
    <form>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="stretch"
        spacing={1}
      >
        <Grid item>
          <TextField
            name="title"
            onChange={handleChangeFields}
            value={state.fields.title}
            fullWidth
            variant="outlined"
            label="عنوان بار"
          />
        </Grid>
        <Grid item>
          <TextField
            type="number"
            name="dangerous"
            onChange={handleChangeFields}
            value={state.fields.dangerous}
            fullWidth
            variant="outlined"
            label="درصدموثر"
          />
        </Grid>
      </Grid>
      <Grid item>
        <input
          name="worker"
          type="checkbox"
          className="form-check-input"
          id="needWorker"
          value={state.fields.worker}
          onChange={handleChangeFields}
          checked={state.fields.worker}
        />
        <label className="form-check-label" htmlFor="needWorker">
          این بار نیاز به کارگر دارد؟
        </label>
      </Grid>
      <Grid item>
        <input
          type="checkbox"
          className="form-check-input"
          id="isSalt"
          name="salt"
          value={state.fields.salt}
          onChange={handleChangeFields}
          checked={state.fields.salt}
        />
        <label className="form-check-label" htmlFor="isSalt">
          این بار از نوع نمک است؟
        </label>
      </Grid>
      <Grid item>
        {state.mode === 'add' ? (
          <Button
            color="primary"
            variant="contained"
            size="medium"
            fullWidth
            onClick={handleSubmitCargoType}
          >
            افزودن
          </Button>
        ) : (
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="stretch"
            spacing={1}
          >
            <Grid item xs={6}>
              <Button
                color="primary"
                variant="contained"
                size="medium"
                fullWidth
                onClick={handleSubmitCargoType}
              >
                ویرایش
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                color="default"
                variant="contained"
                size="medium"
                fullWidth
              >
                صرفنظر
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </form>
  );
  const body = (
    <TwoCards
      title={props.config.name}
      category={
        <TextField
          name="search"
          value={state.fields.search}
          onChange={(e) => handleSearch(e)}
          variant="outlined"
          fullWidth
          label="جستجو"
        />
      }
      secondaryTitle={state.mode === 'add' ? 'افزودن' : 'ویرایش'}
      secondaryContent={theForm}
    >
      <div className="cargoTypes">{cargoTypesTable}</div>
    </TwoCards>
    // <div className="content">
    //   <Grid fluid>
    //     <Row>
    //       <Col md={6} lg={8} sm={12}>
    //         <Card
    //           title={props.config.name}
    //           category={
    //             <input
    //               type="text"
    //               name="search"
    //               className="form-control"
    //               placeholder="جستجو"
    //               value={state.fields.search}
    //               onChange={e => handleSearch(e)}
    //             />
    //           }
    //           content={
    //             <div>
    //               <div className="cargoTypes">{cargoTypesTable}</div>
    //             </div>
    //           }
    //         />
    //       </Col>
    //       <Col md={6} lg={4} sm={12}>
    //         <Card
    //           title={state.mode === "add" ? "افزودن" : "ویرایش"}
    //           category="فرم زیر را تکمیل بفرمایید:"
    //           content={theForm}
    //         />
    //       </Col>
    //     </Row>
    //   </Grid>
    // </div>
  );
  return body;
}
export default CargoTypes;
